import React, { useState } from 'react'
import {Avatar, Button, Paper,  Grid, Typography, Container} from '@material-ui/core'
import useStyles from "./styles"
import {GoogleLogin} from 'react-google-login'
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Input from "./Input"
import Icon from "./icon"
import {useDispatch} from "react-redux";
import {useHistory } from 'react-router-dom'
import {signin, signup} from "../../actions/auth"
const initialState = {firstName:"", lastName:"", email:"", password:"", confirmPassword:""};

const Auth = () => {
    const history = useHistory();
    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(false);
    const handleShowPassword = ()=> {setShowPassword((prevshowPassword) => !prevshowPassword )}
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if(isSignUp){
            dispatch(signup(formData, history));

        }else{
            dispatch(signin(formData, history));

        }

    };

    const handleChange = (e) => {
        setFormData( {...formData, [e.target.name]:e.target.value } )
    };
    const [isSignUp, setSignUp] = useState(false);
    const switchMode = ()=>{ 
        setSignUp((previsSignUp) => !previsSignUp)
        handleShowPassword(false);
    } 
    const dispatch = useDispatch();
        
    const [formData, setFormData] = useState(initialState);

    const googleSuccess= async (res) =>{  
        
        const result = res?.profileObj;
        const token = res?.tokenId;
        console.log(res);

    
        try{
            dispatch({type:'AUTH', data: {result, token}});
            
            history.push('/');
        }
        catch(error){
            console.log(error);
        }

    }

    const googleFailure= (error) =>{
        console.log(error);
        console.log("Google Sign In was Unsuccessful. Try Again Later");
    }


    return(
        <Container component='main' maxWidth="xs">
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon/>
                </Avatar>
                <Typography variant='h5'> {isSignUp ? "Sign Up" : "Sign In"}</Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {
                            isSignUp && (
                                <>
                                        <Input name='firstName' label="First Name" handleChange={handleChange} autoFocus half />
                                        <Input name='lastName' label="Last Name" handleChange={handleChange} half />
                                </>
                            )}
                        

                            <Input name="email" label="Email Address" handleChange={handleChange} type="email" />
                            <Input name="password" label="Password" handleChange={handleChange} type={showPassword?"text":"password"} handleShowPassword={handleShowPassword}/>
                            {isSignUp && <Input name="confirmPassword" label="Repeat Password" handleChange={handleChange} type="password"/>}
                    </Grid>
                    
                    <Button type="submit" fullWidth variant='contained' color='primary' className={classes.submit}> {isSignUp? "Sign Up" : "Sign In"} </Button>
                    <GoogleLogin 
                    clientId="444733996352-vqjnsrksobh8lcpnn440thsba14smjd2.apps.googleusercontent.com"
                    render={(renderProps) => (
                        <Button className={classes.googleButton} color="primary" fullWidth onClick={renderProps.onClick} disable={renderProps.disable} startIcon={<Icon/>} variant="contained">
                            Google Sign In
                        </Button>
                    )}
                    onSuccess={googleSuccess}
                    onFailure={googleFailure}
                    cookiePolicy="single_host_origin" 

                    />
                    <Grid type="container" justify="flex-end" >
                        <Grid type="item">
                            <Button onClick={switchMode} >{isSignUp ? "Already have an account? Sign In" : "Dont have an account? Sign Up"} </Button>
                        </Grid>
                    </Grid>            
                </form>
            </Paper>
            
        </Container>

        
    )
}

export default Auth;
